






















































































import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from "vue";
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import EmptyData from '../../../../../components/EmptyData/EmptyData.vue'
import { SelectOptionData } from '../../../../../components/Pi/types'
import TypeSelect from '../../../../../components/TypeSelect.vue'
import { IterableListItem } from '../../../../utils/IterableItemFactory'
import { getConditionBuilders } from '../conditions'
import { AutoReplyConditions, AutoReplyConditionTypeEnum } from '../types'

@Component({
  data() {
    return {
      isMobile,
    }
  },
  components: {
    TypeSelect,
    EmptyData,
  }
})
export default class ActionCardConditionsGroup extends Vue {
  @VModel() conditions!: Array<IterableListItem<AutoReplyConditions>>

  @Prop() parentGuid!: string

  @Prop() removeGroupDisabled!: boolean

  @Prop() index!: number

  @Prop() conditionOptions!: Array<SelectOptionData>

  @Prop() conditionBuilders!: ReturnType<typeof getConditionBuilders>

  @Emit()
  addCondition(type: AutoReplyConditionTypeEnum): { parentGuid: string, condition: AutoReplyConditions } {
    return {
      condition: this.conditionBuilders?.[type]?.getModel() ?? { type },
      parentGuid: this.parentGuid
    }
  }

  @Emit()
  removeCondition(conditionGuid: string): { parentGuid: string, conditionGuid: string } {
    return { parentGuid: this.parentGuid, conditionGuid }
  }

  @Emit()
  removeGroup(): string {
    return this.parentGuid
  }
}
